import type { AnyFormFinalSetupObject } from "../../../../widgetDataTs.js";
import { doesUsePageOfferId } from "./doesUsePageOfferId.js";
import { getSelectedDocuments, getSelectedVideo } from "./getSelectedResources.js";

export function getDocumentTitle (widgetSetup: AnyFormFinalSetupObject): string | null
{
  const selectedDocs = getSelectedDocuments(widgetSetup);
  if (selectedDocs?.length === 1)
  {
    return selectedDocs[ 0 ].title;
  }
  if (doesUsePageOfferId(widgetSetup))
  {
    return "our content";
  }
  return null;
}


export function getVideoTitle (widgetSetup: AnyFormFinalSetupObject): string | null
{
  const selectedVideo = getSelectedVideo(widgetSetup);
  return selectedVideo?.title ?? null;
}
